import script from "./notfound.vue?vue&type=script&setup=true&lang=js"
export * from "./notfound.vue?vue&type=script&setup=true&lang=js"

import "./notfound.vue?vue&type=style&index=0&id=2299ad3b&lang=css"

const __exports__ = script;

export default __exports__